<template>
    <v-flex class="nonbrowser-view" :class="conitionalLayoutCSS">
       <div v-if="!isInvalidGroup">
        <router-view name="banner" :class="['banner-view', routeConfigHideHeader && 'no-header-layout']" v-if="!hiddenForMobileView"></router-view>
         <div v-if="showNewMemberBannerUI && !$vuetify.breakpoint.xs"  class="new_member_banner">
           <div class="new_member_banner__content">
             <span v-html="welcomeBannerText"></span>
           </div>
         </div>
        <v-layout column v-if="!$vuetify.breakpoint.xs">
            <v-flex
                xs12
                pa-2
                pl-3
                v-for="message in systemMessages"
                :data-qe-id="`system_message_${message.id}`"
                :class="['system-message', message.allUpperCase ? 'system-message--uppercase' : '']"
                :style="{color: message.textColor || appCommonConstants.DEFAULT_SYSTEM_TEXT_COLOR,
                            backgroundColor: message.backgroundColor || appCommonConstants.DEFAULT_SYSTEM_BACKGROUND_COLOR}"
                :key="message.id"
                v-html="message.body">
            </v-flex>
        </v-layout>
         <div class="layout--main">
           <v-layout row wrap class="layout--wrapper">
             <v-flex
                 lg3
                 xs12
                 hidden-md-and-down
                 class="left-side-bar"
                 v-if="$vuetify.breakpoint.lg || $vuetify.breakpoint.xl">
               <quick-links></quick-links>
               <router-view name="leftSidebar"></router-view>
               <PoliciesTerms></PoliciesTerms>
             </v-flex>
             <v-flex
                 md8
                 pl-3
                 pr-3
                 class="feed-block"
                 :class="[(bannerMargin || !hiddenForMobileView) ? 'banner-margin' : '', businessesPage ? 'lg9' : 'lg6', routeConfigHideHeader && 'no-header-layout']"
             >
               <i class="fas fa-bars tab-menu visible-xs"
                  data-qe-id="layout_toggle-sidebar_link"
                  @click="sidebar = !sidebar"></i>
               <v-layout row wrap class="mobile-menu visible-xs" :class="displayMenuNavigations ? 'active': 'in-active'" v-if="!$vuetify.breakpoint.xs">
                 <i class="fas fa-bars" @click='showOrHideMenu' data-qe-id="layout_show-hide_menu_link"></i>
                 <v-flex class="search-field">
                   <span @click="openPeopleSearchPage()" data-qe-id="layout_people-search_link">People</span>
                   <span @click="openEventSearchPage()" data-qe-id="layout_event-search_link">Events</span>
                   <span @click="openCommunitiesSearchPage()" data-qe-id="layout_community-search_link">Communities</span>
                   <span @click="openContentSearchPage()" data-qe-id="layout_content-search_link">Content</span></v-flex>
                 <i class="fas fa-tools" @click="sidebarOpen()" data-qe-id="layout_side-bar-open_link"></i>
               </v-layout>

               <menu-bar :toggleMenu="toggleMenu" @showOrHideMenu="showOrHideMenu" v-if="!$vuetify.breakpoint.xs"></menu-bar>
               <!--  <v-flex class="mobile-menu__search" v-if="mobileSearch">
                   <v-btn @click="openPeopleSearchPage()" class="primary_btn small"><i class="fas fa-users"></i>People</v-btn>
                   <v-btn @click="openEventSearchPage()" class="primary_btn small"><i class="far fa-calendar-alt"></i>Events</v-btn>
                   <v-btn @click="openCommunitiesSearchPage()" class="primary_btn small"><i class="fas fa-users"></i>Communities</v-btn>
                   <v-btn @click="openContentSearchPage()" class="primary_btn small"><i class="fas fa-align-left"></i>Content</v-btn>
                   <i class="fas fa-times mobile-menu__search__close" @click="mobilesearch()"></i>
               </v-flex> -->
               <no-community-affiliation v-if="showNoCommunityAffiliationMessage"></no-community-affiliation>
               <router-view v-else></router-view>
               <back-to-top :bottom="'20px'"></back-to-top>
             </v-flex>
             <!--   Sidebar for Desktop view  -->
             <v-flex
                 lg3
                 md4
                 xs12
                 class="right-side-bar desktop-view"
                 v-if="$vuetify.breakpoint.lg || $vuetify.breakpoint.xl">
               <router-view name="rightSidebar"></router-view>
             </v-flex>
             <!--   Sidebar for Responsive view  -->
             <v-flex
                 lg3
                 md4
                 xs12
                 class="right-side-bar sidebar-tabView"
                 v-else
                 :class="{ active: sidebar }">
               <v-flex class="sidebar-tabView__cont">
                 <i class="fas fa-times sidebar-tabView__cont__close" @click='sidebar = !sidebar' data-qe-id="layout_secondary_side-bar_toggle_link"></i>
                 <quick-links></quick-links>
                 <router-view name="leftSidebar"></router-view>
                 <router-view name="rightSidebar"></router-view>
                 <PoliciesTerms></PoliciesTerms>
               </v-flex>
             </v-flex>
           </v-layout>
         </div>
       </div>
       <div v-else class="invalid--layout--wrapper" >

            <span>{{communityCommonConstant.group.COMMUNITY_NO_LONGER_EXIST}}</span>

            <a><span @click="openCommunitiesSearchPage()">{{communityCommonConstant.group.COMMUNITY_DIRECTORY}}</span></a>

            <span>{{communityCommonConstant.group.FOR_FULL_LIST_OF_ACTIVE_COMMUNITIES}}</span>

        </div>
    </v-flex>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from "vuex";
    import MenuBar from './Menu';
    import QuickLinks from '../Tools/QuickLinks/QuickLinks.vue';
    import BackToTop from './BackToTop.vue';
    import {
        routerNames,
        menuOptions,
        userRoles,
        appCommonConstants,
    } from "../appCommon.constants";
    import { communityCommonConstant } from "../ChapterPage/communityCommon.constant";
    import { storeGetters } from '@/store/storeGetters.constant';
    import NoCommunityAffiliation from "../NetworkPage/NoCommunityAffiliation.vue";
    import { storeAction } from "../../store/storeActions.constant";
    import moment from "moment";
    import PoliciesTerms from "../Tools/QuickLinks/PoliciesAndTerms";
    import { getWelcomeBannerText, userTypes, showNewMemberBanner } from "@/components/MyAccount/myaccount.constants";

    export default {
        name: "Layout",
        created() {
            if (this.hasCommunityIdInRoute) {
             this.getCommunityById();
            }
            this.getSystemMessages();
        },
        components: {
            MenuBar,
            QuickLinks,
            BackToTop,
            NoCommunityAffiliation,
            PoliciesTerms,
        },
        data: () => {
            return {
                userRoles,
                routerNames,
                communityCommonConstant,
                appCommonConstants,
                menuOptions,
                collapsed: false,
                sidebar: false,
                toggleMenu: false,
                mobileSearch: false,
            };
        },
        computed: {
            ...mapGetters({
                currentCommunityView: `${storeGetters.currentCommunityView}`,
                getRequestedMembers: `network/${storeGetters.getRequestedMembers}`,
                getInviteSomeOne: `network/${storeGetters.getInviteSomeOne}`,
                usersCommunitiesList: `chapter/${storeGetters.usersCommunitiesList}`,
                systemMessages: `notification/${storeGetters.systemMessages}`,
                renewalStatus: `myAccount/${storeGetters.renewalStatus}`,
                isMobileAppBrowser: `${[storeGetters.isMobileAppBrowser]}`,
                communityIdPromise: `${storeGetters.communityIdPromise}`,
                communityInfo: `chapter/${storeGetters.communityInfo}`,
                errorFetchingCommunityData: `chapter/${storeGetters.errorFetchingCommunityData}`,
                routeConfigHideHeader: `${[storeGetters.routeConfigHideHeader]}`,
                routeConfigEngagementApp: `${[storeGetters.routeConfigEngagementApp]}`,
                profileInformation: `myAccount/${storeGetters.profileInformation}`,
            }),
            welcomeBannerText() {
                const target = this.isMobileAppBrowser ? '_self' : '_blank';
                return getWelcomeBannerText(this.profileInformation, target);
            },
            showNewMemberBannerUI() {
                return showNewMemberBanner(this.profileInformation, this.$route.name);
            },
            hasCommunityIdInRoute() {
                return !!this.$route.params.communityId;
            },
            isHomePage() {
                return this.$route.name === this.routerNames.HOME;
            },
            isChapterPage() {
                return this.$route.name === this.routerNames.CHAPTER;
            },
            isNetworkPage() {
                return this.$route.name === this.routerNames.NETWORK;
            },
            isForumPage() {
                return this.$route.name === this.routerNames.FORUM;
            },
            isRegionPage() {
                return this.$route.name === this.routerNames.REGION;
            },
            isGroupPage() {
                return this.$route.name === this.routerNames.GROUP;
            },
            bannerMargin() {
                return (this.$route.name === this.routerNames.HOME && this.renewalStatus.showBanner)
                    || this.$route.name.toLowerCase() === this.routerNames.BUSINESSES.toLowerCase();
            },
            businessesPage() {
                return this.$route.name === this.routerNames.BUSINESSES;
            },
            showNoCommunityAffiliationMessage() {
                return (this.isChapterPage || this.isNetworkPage || this.isForumPage || this.isRegionPage || this.isGroupPage) && (!this.hasCommunityIdInRoute && this.usersCommunitiesList && !this.usersCommunitiesList.some(c =>
                    c.communityType.toLowerCase() === this.$route.name.toLowerCase()) && this.currentCommunityView === userRoles.MEMBER);
            },
            displayMenuNavigations() {
                return !(this.isChapterPage && this.currentCommunityView === this.userRoles.ADMIN);
            },
            hiddenForMobileView() {
            return (
                this.$route.name.toLowerCase() === this.routerNames.HOME.toLowerCase() ||
                this.$route.name.toLowerCase() === this.routerNames.BUSINESSES.toLowerCase()) && this.$vuetify.breakpoint.xs;
            },
            hybridUiExperienceException() {
                return this.$route && this.$route.name
                    && this.$route.name.toLowerCase() === routerNames.BUSINESSES.toLowerCase()
                    && this.isMobileAppBrowser;
            },
            hasSystemMessage() {
                if (this.systemMessages && !this.routeConfigEngagementApp) {
                    return this.systemMessages.length > 0;
                }
                return false;
            },
            conitionalLayoutCSS() {
              let result = "";
                if (this.$route.name.toLowerCase() === this.routerNames.BUSINESSES.toLowerCase()) {
                  result = '';
                } else if (this.hybridUiExperienceException && this.hasSystemMessage) {
                  result = 'hybrid-view nonbrowser-view';
                } else if (this.hybridUiExperienceException) {
                  result = 'hybrid-view';
                } else if (this.hasSystemMessage) {
                  result = 'nonbrowser-view';
                } else if (!this.hasSystemMessage) {
                  result = 'nonbrowser-view-no-banner';
                }
                if (this.routeConfigHideHeader) {
                  result = "layout-no-header";
                }
                result = this.getStylesBasedOnBanner(result);
                return result;
            },
            isInvalidGroup() {
                return (!this.isHomePage && this.hasCommunityIdInRoute && this.errorFetchingCommunityData);
            },
        },
        methods: {
            ...mapActions({
                getSystemMessages: `notification/${storeAction.getSystemMessages}`,
                getRenewalStatus: `myAccount/${storeAction.getRenewalStatus}`,
                getCommunityById: `chapter/${storeAction.getCommunityById}`,
            }),
            showOrHideMenu() {
                this.toggleMenu = !this.toggleMenu;
            },
            sidebarOpen() {
                this.sidebar = true;
                this.toggleMenu = false;
            },
            mobilesearch() {
                this.mobileSearch = !this.mobileSearch;
                this.toggleMenu = false;
            },
            openEventSearchPage() {
                this.$router.push({
                    path: "/eventDirectoryPage",
                });
            },
            openCommunitiesSearchPage() {
                this.$router.push({
                    path: "/communityDirectoryPage",
                });
            },
            openContentSearchPage() {
                this.$router.push({
                    path: "/contentDirectoryPage",
                });
            },
            openPeopleSearchPage() {
                this.$router.push({
                    path: "/memberDirectoryPage",
                    query: {
                        navigatedFromId: this.$route.params && this.$route.params.communityId ?
                            this.$route.params.communityId : "",
                        searchText: this.peopleSearchText ? this.peopleSearchText : "",
                    },
                });
            },
          getStylesBasedOnBanner(containerCss) {
              let result = containerCss;
              let bannerCount = 0;
              if (this.systemMessages && this.systemMessages.length) {
                bannerCount += this.systemMessages.length;
              }
              if (this.showNewMemberBannerUI) {
                bannerCount += 1;
              }
              if (bannerCount) {
                result = `${result} mobile-banner-wrapper--${bannerCount}`;
              }
              return result;
          },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_commonClasses.scss";
    @import "../../common/styles/_responsive.scss";

    .layout--main {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .layout--wrapper{
        max-width: 2000px;
        margin: 2% 4%;


      @include breakpoint(xl) {
          margin: 2% 1%;
        }
      @include breakpoint(lg) {
            margin: 20px 8px;
        }

        @include breakpoint(md){
            margin: 1%;
        }

        @include breakpoint(sm) {
            margin: 2% 4.5%;
        }

        @include breakpoint(xs) {
            margin: 0;
        }
    }
    .invalid--layout--wrapper{
        margin: 8% 8%;
        align-content: center;
        justify-content: center;
        text-align: center;
    }
    .about-section,
    .txhub-section {
        box-shadow: none;

        .v-icon {
            font-size: 19px;
        }

        p {
            padding: 0 20px;
            margin-top: 15px;
        }

        .v-expansion-panel__container {
            border-radius: 4px;
        }

        .v-expansion-panel__header {
            padding: 0;
            min-height: inherit;

            h2 {
                border-bottom: none;
                margin: 0;
                padding: 0;
            }
        }

        .v-list__tile__title {
            color: $ypo-blue-dark-background;
            font-family: Raleway, sans-serif;
            font-size: 20px;
            letter-spacing: 0.17px;
            line-height: 29px;
            margin-bottom: 5px;
        }

        .v-list__tile__sub-title {
            color: $black;
            font-family: Raleway, sans-serif;
            font-size: 14px;
            font-weight: 600;
            letter-spacing: 0.46px;
            line-height: 16px;
        }
    }

    .system-message {
        font-size: 14px;

        &--uppercase {
            text-transform: uppercase;
        }

        @include breakpoint(xs) {
            font-size: 11px;
        }
    }

    .message_about {
        background: $ypo-extra-light-gray;
        border: 1px solid $ypo-medium-gray;
        margin: 10px;
        border-radius: 4px;

        h2 {
            font-size: 20px;
        }
    }

    .about_more {
        border: 1px solid $ypo-medium-gray;
        margin: 10px;
        border-radius: 4px;
        background-color: rgba($ypo-gold, 0.1);
    }

    .ypo_international {
        padding: 8px;

        .v-card {
            margin: 5px;
            background: $ypo-extra-light-gray;
        }

        .v-card__title {
            padding: 5px 0;
            text-align: center;
            display: block;
            font-size: 12px;
            color: $ypo_blue;
        }
    }

    .files-media {
        padding: 15px 0px;
        border-bottom: 1px solid $ypo-medium-gray;
        margin: 0 15px;

        strong {
            font-weight: 400;
            color: $ypo-dark-background-gray;
            font-family: "Noto Sans", sans-serif;
            font-size: 16px;
            letter-spacing: 0.25px;
            line-height: 18px;
        }

        small {
            display: block;
            color: $ypo-gray-text;
            font-size: 10px;
            letter-spacing: 0.3px;
            line-height: 10px;
            margin-top: 10px;
        }

        i {
            font-size: 26px;
            color: $ypo_blue;
        }

        &__icon {
            text-align: center;

            small {
                margin-top: 3px;
            }
        }
    }

    .chapter-health {
        .update {
            align-items: center;
            color: $ypo-blue;
        }
    }

    h6 {
        font-size: 14px;
        color: $ypo-blue;
        font-weight: normal;
        margin-bottom: 15px;
    }

    .sidebar-tabView {
        display: none;
    }

    .sidebar-tabView__cont__close {
        display: none;
    }

    @media (max-width: 1300px) {
        .nav_links {
            a {
                padding: 18px 14px;
            }
        }
    }

    .chapter-health {
        .update {
            align-items: center;
            color: $ypo-blue;
        }

    }

    @media (max-width: 1263px) {
        .desktop-view {
            display: none;
        }

        .sidebar-tabView {
            display: block;
        }
    }

    @media only screen and (min-width: 1264px) and (max-width: 1420px) {
      .left-side-bar {
        max-width: 23%;
        flex-basis: 23%;
      }
      .feed-block {
        max-width: 54%;
        flex-basis: 54%;
      }
      .right-side-bar {
        max-width: 23%;
        flex-basis: 23%;
      }
    }

    @media (max-width: 1183px) {
        .sidebar-tabView {
            display: block;
        }
    }
    @media (max-width: 1023px) {

        .feed-block {
            max-width: 100%;
            flex: inherit;
            padding-left: 16px !important;
        }

        .sidebar-tabView {
            display: none;

            &.active {
                position: fixed;
                right: 0;
                top: 0;
                width: 350px;
                z-index: 100;
                display: block;
                max-height: 100vh;
                overflow-y: auto;

                .over-lay {
                    opacity: 1;
                }
            }

            .over-lay {
                position: relative;
                opacity: 0;

                &:before {
                    content: "";
                    position: fixed;
                    width: 100%;
                    background: rgba($black, 0.15);
                    left: 0;
                    top: 0;
                    height: 100%;
                }
            }

            &__cont {
                position: relative;
                z-index: 1;
                background: $ypo-extra-light-gray;
                padding: 40px 10px 70px 10px;

                &__close {
                    position: absolute;
                    left: 10px;
                    top: 10px;
                    font-size: 20px;
                    color: $ypo_blue;
                    z-index: 1;
                    display: block;
                }
            }

        }

        .tab-menu {
            display: inline;
            position: absolute;
            border: 1px solid $ypo-about-border;
            padding: 15px 12px;
            font-size: 20px;
            cursor: pointer;
            color: $ypo_blue;
            border-radius: 4px;

        @include breakpoint(md) {
            left: -32px;
        }
    }


    }

    @media (max-width: 767px) {
        .tab-menu {
            display: none;
        }

        .sidebar-tabView {
            &.active {
                width: 100%;
            }
        }

        .mobile_breadcrumb {
            margin-top: 100px;

            a {
                text-decoration: none;
                font-size: 12px;

                &.disabled {
                    color: $ypo_gold;
                }
            }

            .v-breadcrumbs__divider {
                padding: 0 5px !important;
            }
        }
    }
</style>

<style lang="scss">
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_commonClasses.scss";

    .sub-menu__tabs {
        padding-left: 0 !important;

        .v-tabs {
            &__wrapper--show-arrows {
                margin-left: 0;
                margin-right: 0;
            }

            &__icon {
                font-size: 22px;
                color: $white;
                background: rgb(32, 65, 100) !important;
                z-index: 100;

                &--prev {
                    margin-left: -5px;
                }

                &--next {
                    margin-right: -5px;
                }
            }

            &__div {
                max-width: none;
            }

            &__bar {
                background: rgb(32, 65, 100) !important;
            }

            &__item {
                text-transform: none;
                color: $white;
                font-size: 12px;
                opacity: 0.5 !important;
                text-decoration: none;

                &:hover {
                    opacity: 1 !important;
                }

                &--active {
                    opacity: 1 !important;
                }
            }
        }
    }

    .mobile-menu__dropdown {
        .v-expansion-panel__header {
            padding: 15px 20px;
        }

        h2 {
            font-size: 16px;
            color: $ypo-cta;
            font-weight: 500;
        }

        .v-expansion-panel {
            border-bottom: 1px solid rgba($black, 0.12);
            box-shadow: none;
        }

        .v-tabs__container {
            height: auto;
            display: block;
        }

        .v-tabs__div {
            display: block;
            min-width: 100%;
            text-align: left;
            text-transform: inherit;

            a {
                border: none;
                padding: 10px 20px;
                opacity: 1;
                margin: 0;
                display: block;
                width: 100%;
                white-space: inherit;
            }

        }

        .v-tabs__item--active {
            color: $ypo-blue;
            font-weight: 600;
        }

        .v-tabs__slider-wrapper {
            display: none;
        }
    }

    .breadcrumbs__wrapper {
      .v-breadcrumbs li:nth-child(even) {
        color: rgba($white, 0.5) !important;
      }
    }

    @include breakpoint(xs) {
        .nonbrowser-view {
            padding-top: 56px;
            background: $white;
        }

        .nonbrowser-view-no-banner {
            padding-top: 0px;
            background: $white;
        }
    }

    .hybrid-view {
        padding-top: 0;
    }

    .layout-no-header {
      padding-top: 10px !important;
    }

    .new_member_banner {
      position: relative;
      z-index: 2;
      width: 100vw;
      color: white;
      padding: 5px 15px;
      background-color: $ypo-blue-secondary;

      &__content {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .mobile-banner-wrapper {
      &--1 {
        @include breakpoint(xs) {
          .feed-block {
            margin-top: 120px;
          }
        }
      }

      &--2 {
        @include breakpoint(xs) {
          .feed-block {
            margin-top: 140px;
          }
        }
      }

      &--3 {
        @include breakpoint(xs) {
          .feed-block {
            margin-top: 220px;
          }
        }
      }
    }
</style>
